import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

const select = (state: RootState) => state.notice;

export const noticesSelector = createSelector(
  select,
  (notice) => notice.notices,
);
